export default "__VITE_ASSET__d1c69867__"